module.exports = __webpack_public_path__ + "static/media/logo.ecf63c55.png";